<script>
    import {onMount} from 'svelte';

    import {userStore} from '@js/stores/userStore';
    import {mapStore} from '@js/stores/mapStore';

    import {MAP_CLASS, MAP_MODULES} from '@js/modules/maps/mapConstants';
    import MapBuilder from '@js/modules/maps/MapBuilder';

    import MapLayers from '@js/components/maps/MapLayers.svelte';

    const {
        mapId,
        initialLocation,
        searchOnZoom = false,
        searchParams,
        rides
    } = $props();

    let _previousUnit = userStore.unit;
    let _unsubscribeUnit;

    const _handleMapStyleChange = (mapStyle) => {
        if (!mapStore.map) {
            return;
        }

        mapStore.map.setMapStyle(mapStyle);
    };

    const _handleFontSizeChange = (delta) => {
        if (!mapStore.map) {
            return;
        }

        mapStore.map.changeMapFontSize(delta);
    };

    const _displayRides = () => {
        if (!mapStore.map) {
            return;
        }

        mapStore.map.onMapLoaded(() => {
            mapStore.map.showSelected({
                ridesData: $state.snapshot(rides),
                filter: searchParams,
                clearBounds: true
            });
        });
    };

    const _loadListMap = () => {
        MapBuilder.createMap(
            MAP_CLASS.SEARCH,
            [
                MAP_MODULES.RIDE_MARKERS,
                MAP_MODULES.RIDE_TRACK
            ],
            {
                minZoom: 12,
                mapId,
                initialLocation,
                ridesData: $state.snapshot(rides),
                resetBounds: true,
                clusterMode: true,
                searchOnZoom: searchOnZoom,
                filter: searchParams,
                isMapSearch: false,
                rideTrackMultiple: true,
                onDoneLoading: _displayRides
            }
        )
            .then((map) => {
                mapStore.map = map;

                _unsubscribeUnit = userStore.subscribe((userState) => {
                    if (userState.unit !== _previousUnit) {
                        _previousUnit = userState.unit;

                        mapStore.map.onUnitChanged(userState.unit);
                    }
                });
            });
    };

    $effect(() => {
        const ridesCount = rides?.length;

        if (!mapStore.map || ridesCount === undefined) {
            return;
        }

        _displayRides();
    });

    onMount(() => {
        if (!mapStore.map) {
            _loadListMap();
        }

        return () => {
            // The store outlives the page: a unit change must not reach the destroyed map.
            _unsubscribeUnit?.();
            if (mapStore.map) {
                mapStore.map.destroy();
                mapStore.map = null;
            }
        };
    });
</script>

<div id={mapId}
     class="my-4">
    <div class="map-area">
        <div id={`${mapId}-map`}
             class="map-canvas map-read-only">
            {#if $userStore.featureFlags.map_available_layers?.length}
                <MapLayers mapLayersAvailable={$userStore.featureFlags.map_available_layers}
                           map={$mapStore.map}
                           onMapStyleChange={_handleMapStyleChange}
                           onFontSizeChange={_handleFontSizeChange}/>
            {/if}

        </div>
    </div>
</div>
